import styles from "../Stats.module.css";
import { PlayedStakesInfo } from "./PlayedStakesInfo";
export const MostPlayedStakes = ({ mostPlayedStakes }) => {
  return (
    <>
      {mostPlayedStakes && mostPlayedStakes.length && (
        <div className="most-played-stakes-section mt-[16px]">
          <div className={`text-primary font-medium`}>Most Played Stakes</div>
          <div
            className={`${styles.coreCardConfigBkNoBorder} px-4 pt-2 pb-3 flex flex-col gap-2 mt-3`}
          >
            {mostPlayedStakes.map((item, index) =>
              Object.keys(item).length ? (
                <PlayedStakesInfo
                  item={item}
                  index={index}
                  key={item?.sno}
                  mostPlayedStakes={mostPlayedStakes}
                />
              ) : null
            )}
          </div>
        </div>
      )}
    </>
  );
};
